// useConsoleSyncCustomer stub - Console sync functionality discontinued

export function useConsoleSyncCustomer() {
  return {
    syncCompanyToConsole: async (_company: any) => ({ success: false, error: 'Funcionalidade descontinuada' }),
    canSync: (_company: any) => false,
    getSyncValidationMessage: (_company: any) => 'Funcionalidade descontinuada'
  };
}

export default useConsoleSyncCustomer;
